import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { UsersEntityGrid } from '../features/users-entity-grid';

export const AllUsersPage = observer(() => {
  return (
    <AppPage perm="PERM_USER_READ" noWrapper>
      <UsersEntityGrid />
    </AppPage>
  );
});
